import Vue from 'vue'

const utils = {
  install (V) {
    Vue.prototype.util = new Vue({
      data () {
        return {
          transitionEndEvent: null,
          animationEndEvent: null
        }
      },
      methods: {
        whichTransitionEvent () {
          let t
          let el = document.createElement('fakeelement')

          let transitions = {
            'transition': 'transitionend',
            'OTransition': 'oTransitionEnd',
            'MozTransition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd'
          }

          for (t in transitions) {
            if (el.style[t] !== undefined) {
              return transitions[t]
            }
          }
        },

        whichAnimationEvent () {
          let t
          let el = document.createElement('fakeelement')

          let animations = {
            'animation': 'animationend',
            'OAnimation': 'oAnimationEnd',
            'MozAnimation': 'animationend',
            'WebkitAnimation': 'webkitAnimationEnd'
          }

          for (t in animations) {
            if (el.style[t] !== undefined) {
              return animations[t]
            }
          }
        },

        init () {
          this.transitionEndEvent = this.whichTransitionEvent()
          this.animationEndEvent = this.whichAnimationEvent()
        },

        getFirstQuestionForCategoryNotAnswered (catCases, progress) {
          // Not started the question
          if (progress.length === 0) {
            return catCases[0]
          }

          // Have done all question
          if (progress.length === catCases.length) {
            return false
          }

          // Need to copy the array as the setup was not done for this initially
          let tmpArray = this.copyArrayByField(progress, 'name')
          // for (let y = 0; y < progress.length; y++) {
          //   tmpArray.push(progress[y].name)
          // }

          for (let i = 0; i < catCases.length; i++) {
            if (!this.arrayContainsValue(catCases[i], tmpArray)) {
              return catCases[i]
            }
          }
          return false
        },

        copyArrayByField (copyArr, field) {
          let tmpArray = []
          for (let y = 0; y < copyArr.length; y++) {
            tmpArray.push(copyArr[y][field])
          }
          return tmpArray
        },

        getCorrectCount (arr, length) {
          let correct = 0
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].aicd) {
              correct++
            }
          }
          return (correct + '/' + length)
        },

        /**
         * Replaces content of string with placeholder/s
         * Placeholder string should have the format of "blabla {0} blabla {1} ..."
         * {index} is replaced in order by the replacement (which can be string or array)
         *
         * @param {string} placeholderString - string that contains placeholders
         * @param {*} replacement - Can be a string or array of strings
         * @returns {*} - returns the string with the placeholders replaced, or false if there was a problem
         */
        replacePlaceholderWithString (placeholderString, replacement) {
          let repl = null
          if (replacement instanceof Array) {
            repl = replacement
          } else {
            repl = [replacement]
          }

          if (typeof placeholderString === 'string' && (repl instanceof Array)) {
            return placeholderString.replace(/({\d})/g, function (i) {
              return repl[i.replace(/{/, '').replace(/}/, '')]
            })
          } else if (typeof placeholderString === 'string' && (repl instanceof Object)) {
            for (let key in repl) {
              return placeholderString.replace(/({([^}]+)})/g, function (i) {
                let key = i.replace(/{/, '').replace(/}/, '')
                if (!repl[key]) {
                  return i
                }

                return repl[key]
              })
            }
          } else {
            return false
          }
        },

        indexOfwithPollyfill: function (searchElement, array, fromIndex) {
          if (!Array.prototype.indexOf) {
            let k
            if (array == null) {
              throw new TypeError('"this" is null or not defined')
            }
            let O = Object(array)
            let len = O.length >>> 0
            if (len === 0) {
              return -1
            }
            let n = +fromIndex || 0
            if (Math.abs(n) === Infinity) {
              n = 0
            }
            if (n >= len) {
              return -1
            }
            k = Math.max(n >= 0 ? n : len - Math.abs(n), 0)
            while (k < len) {
              if (k in O && O[k] === searchElement) {
                return k
              }
              k++
            }
            return -1
          } else {
            return array.indexOf(searchElement) > -1
          }
        },

        /**
         * Compares two objects for equality
         * @param {object} objA - first object
         * @param {object} objB - second object
         * @returns {boolean}
         */
        objectsAreEqual (objA, objB) {
          // Create arrays of property names
          let aProps = Object.getOwnPropertyNames(objA)
          let bProps = Object.getOwnPropertyNames(objB)

          // Some browser creates a __ob__ element at the end of the property name array
          if (bProps[(bProps.length - 1)] === '__ob__') {
            bProps.splice((bProps.length - 1), 1)
          }

          // If number of properties is different,
          // objects are not equivalent
          if (aProps.length !== bProps.length) {
            return false
          }

          for (let i = 0; i < aProps.length; i++) {
            let propName = aProps[i]

            // If values of same property are not equal,
            // objects are not equivalent
            if (objA[propName] !== objB[propName]) {
              return false
            }
          }

          // If we made it this far, objects
          // are considered equivalent
          return true
        },

        jsonCopyObject (obj) {
          if (JSON) {
            return JSON.parse(JSON.stringify(obj))
          }
          return false
        },

        objectIsInArray (obj, objArray) {
          for (let i = 0; i < objArray.length; i++) {
            if (this.objectsAreEqual(obj, objArray[i])) {
              return true
            }
          }
          return false
        },

        addBodyClass (className) {
          let classes = document.getElementsByTagName('body')[0].className
          if (classes !== '') {
            let parts = classes.split(' ')
            for (let i = 0; i < parts.length; i++) {
              if (parts[i] === className.trim()) {
                return false
              }
            }
          }
          document.getElementsByTagName('body')[0].className += className + ' '
        },

        getBgUrl (el) {
          let bg = ''
          if (el.currentStyle) { // IE
            bg = el.currentStyle.backgroundImage
          } else if (document.defaultView && document.defaultView.getComputedStyle) { // Firefox
            bg = document.defaultView.getComputedStyle(el, '').backgroundImage
          } else { // try and get inline style
            bg = el.style.backgroundImage
          }
          return bg.replace(/url\(['"]?(.*?)['"]?\)/i, '$1')
        },

        removeBodyClass (className) {
          let classes = document.getElementsByTagName('body')[0].className.trim()
          if (classes !== '') {
            let parts = classes.split(' ')
            let remainder = ''
            for (let i = 0; i < parts.length; i++) {
              if (parts[i] !== className) {
                remainder += parts[i] + ' '
              }
            }
            document.getElementsByTagName('body')[0].className = remainder
          }
        },

        scrollTop (el) {
          if (el === undefined) {
            window.scrollTo(0, 0)
          } else {
            el.scrollTo(0, 0)
          }
        },

        arrayContainsValue (value, array, fromIndex) {
          let from = fromIndex !== undefined ? fromIndex : 0
          return this.indexOfwithPollyfill(value, array, from)
        },

        arrayContainsObjectValue (value, array) {
          for (let i = 0; i < array.length; i++) {
            if (array[i] === value) {
              return array[i]
            }
          }
          return false
        }
      }
    })
  }
}

if (window !== undefined && window.Vue) {
  window.Vue.use(utils)
}

export default utils



// WEBPACK FOOTER //
// ./src/plugins/vue-util/index.js